import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { fromJS, List, Map } from 'immutable'
import { getPageUID, IS_DATA_CONTAINER } from '../../lib/getValueByType'
import { doProcessRules, getParams, getQueryVariable, getState, updateOldValue } from '../../lib/processPortalRules'

const axios = getAxios()

export const processSfPlatformPush = (sett, afterFinishActions) => async (dispatch, getAppState) => {
  let state = getAppState()

  let listEvents = state.getIn(['project', 'Settings', 'sfPlatformEvents'])
  let event
  if (listEvents) {
    listEvents = listEvents.toJS()
    event = _.find(listEvents, (row) => row.uid == sett.action)
  }

  if (!event) {
    return {
      status: false,
    }
  }

  const params = getParams(state)
  const widgetState = getState(state)
  const path = []
  if (event.action == 'subscribe') {
    if (typeof window?.__FT_PROJECT__API__?.subscribeSFEvent === 'function') {
      let requestData = {}
      _.each(event.fields, (field) => {
        if (_.startsWith(field, 'param#-#')) {
          let paramId = _.last(String(field).split('#-#'))
          const keyConf = [...path, paramId]
          requestData[field] = _.get(params, keyConf, '')
          if (requestData[field]) {
            requestData[`prot_${paramId}`] = _.get(params, [`prot_${paramId}`], '')
          }
        } else if (_.startsWith(field, 'params#-#')) {
          const keyConf = _.last(String(field).split('#-#')).split(/:/g)
          requestData[field] = _.get(params, keyConf, '')
        } else if (_.startsWith(field, 'smartv')) {
          const keyConf = _.last(String(field).split('#-#')).split(/:/g)
          requestData[field] = _.get(getPreviewDynamicData(), ['svParams', keyConf], '')
        } else {
          let keyConf = _.concat(updateOldValue(field).split('#-#')[1].split(':')).join('.')
          requestData[field] = _.get(widgetState, keyConf, '')
        }
      })

      const unsubscribe = window.__FT_PROJECT__API__.subscribeSFEvent(
        {
          uid: event.uid,
          query: requestData,
          projectID: state.getIn(['project', '_id']),
          isPreview: window.location.href.includes('ftnocache'),
        },
        (reply) => {
          if (reply.status) {
            let retState = getAppState()

            let replyData = reply.data
            let changesPath = []
            _.each(replyData, (val, key) => {
              let uid = key.split('#-#')[1]
              if (!uid) {
                return true
              }
              if (String(key).startsWith('param#-#')) {
                changesPath.push([uid])
                retState = retState.setIn(['params', uid], val)
              } else if (String(key).startsWith('view:')) {
                let path = uid.split(':')
                changesPath.push(path)
                retState = retState.setIn(['state', ...path], val)
              }
            })

            if (changesPath.length) {
              retState = doProcessRules(
                retState,
                Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
                [],
                [],
                changesPath,
                false,
                false
              )
            }
            retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(afterFinishActions))
            dispatch({
              type: actionTypes.SET_STORE,
              payload: {
                store: retState,
              },
            })
          }
        }
      )
    }
  } else {
    let requestData = {}
    _.each(event.fields, (field) => {
      if (_.startsWith(field, 'param##')) {
        let paramId = _.last(String(field).split('##'))
        const keyConf = [...path, paramId]
        requestData[field] = _.get(params, keyConf, '')
        if (requestData[field]) {
          requestData[`prot_${paramId}`] = _.get(params, [`prot_${paramId}`], '')
        }
      } else if (_.startsWith(field, 'params##')) {
        const keyConf = _.last(String(field).split('##')).split(/:/g)
        requestData[field] = _.get(params, keyConf, '')
      } else if (_.startsWith(field, 'smartv')) {
        const keyConf = _.last(String(field).split('##')).split(/:/g)
        requestData[field] = _.get(getPreviewDynamicData(), ['svParams', keyConf], '')
      } else {
        let newKey = updateOldValue(field)
        if (String(newKey).includes('##')) {
          newKey = newKey.split('##')[1].split(':')
        } else if (String(newKey).includes('#-#')) {
          newKey = newKey.split('#-#')[1].split(':')
        }

        let keyConf = _.concat(newKey).join('.')
        requestData[field] = _.get(widgetState, keyConf, '')
      }
    })

    const recursiveProcessPush = async (attemp) => {
      if (attemp >= 3) {
        return {
          status: 200,
          data: {
            status: false,
          },
        }
      }
      try {
        let result = await axios.post('/webprojects/push/sfevent', {
          data: requestData,
          action: event.uid,
        })
        return result
      } catch (err) {
        console.log('err >>> ', err)
        let errorMessage = `You are offline, trying again in 2 seconds...`
        try {
          if (String(err).indexOf('413') > -1) {
            dispatch({
              type: actionTypes.NOTIFY_ERROR,
              payload: {
                key: uuid(),
                message: 'Request Entity Too Large',
              },
            })
            return {
              data: {
                status: false,
              },
            }
          } else if (navigator.onLine) {
            errorMessage = `Bad response, trying again in 2 seconds...`
          }
        } catch (e) {}
        await new Promise((resolve) => {
          setTimeout(resolve, 2 * 1000)
        })

        return recursiveProcessPush(attemp + 1)
      }
    }
    const { status, data } = await recursiveProcessPush(0)

    let retState = getAppState()
    retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(afterFinishActions))
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: retState,
      },
    })
  }
}
